"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorrowerChargesCode = void 0;
var BorrowerChargesCode;
(function (BorrowerChargesCode) {
    BorrowerChargesCode["BalanceOfFirstOutstandingMortgage"] = "029";
    BorrowerChargesCode["BCSpecialPayment"] = "030";
    BorrowerChargesCode["SettlementPaymentInLieuOfJudgement"] = "050";
    BorrowerChargesCode["PropertyDamage"] = "070";
    BorrowerChargesCode["InsuranceSettlement"] = "071";
    BorrowerChargesCode["InsurancePropertyInsurancePremium"] = "100";
    BorrowerChargesCode["PropertyManagementFee"] = "110";
    BorrowerChargesCode["SecondListingPropertyManagement"] = "115";
    BorrowerChargesCode["TaxesPriorToDefault"] = "120";
    BorrowerChargesCode["TaxesAfterDefault"] = "130";
    BorrowerChargesCode["LegalFees"] = "140";
    BorrowerChargesCode["LegalDisbursements"] = "150";
    BorrowerChargesCode["EvictionContestFees"] = "160";
    BorrowerChargesCode["EvictionContestDisbursements"] = "170";
    BorrowerChargesCode["UtilityExpense"] = "180";
    BorrowerChargesCode["EsaCosts"] = "190";
    BorrowerChargesCode["CondominiumStrataFees"] = "202";
    BorrowerChargesCode["GroundSiteRent"] = "203";
    BorrowerChargesCode["MechanicsBuildersLiensConditionalSalesContracts"] = "204";
    BorrowerChargesCode["Appraisals"] = "301";
    BorrowerChargesCode["PropertyRepairs"] = "305";
    BorrowerChargesCode["Other"] = "999";
})(BorrowerChargesCode = exports.BorrowerChargesCode || (exports.BorrowerChargesCode = {}));
